<template>
  <span>
    <highcharts :options="chartOptions" :deepCopyOnUpdate="false" />
  </span>
</template>

<script>
  import columnChartMixin from "./columnChartMixin";

  export default {
    name: "ColumnChartMensal",
    mixins: [columnChartMixin],
    props: {
      dadosMensais: {
        type: Object,
        required: true,
      },
      metasKpis: {
        type: Object,
        required: true,
      },
      categories: {
        type: Array,
        required: true,
      },
      indicador: {
        type: String,
        required: true,
      },
    },
    data: () => ({
      chartOptions: {},
    }),
    mounted() {
      this.setChartOptions();
    },
    methods: {
      setChartOptions() {
        this.chartOptions = this.getColumnChartOptions(
          this.getRemainingChartOptions()
        );
      },
      getRemainingChartOptions() {
        return {
          xAxis: {
            type: "category",
            categories: this.categories,
            title: {
              text: "Competência",
            },
          },
          legend: { enabled: true },
          series: [
            {
              name: this.indicador.toUpperCase(),
              data: this.categories
                .map((category) => {
                  return category in this.dadosMensais
                    ? {
                        x: this.categories.indexOf(category),
                        y: Number(this.dadosMensais[category][this.indicador]),
                      }
                    : {
                        x: this.categories.indexOf(category),
                        y: 0,
                      };
                })
                .filter((val) => val !== null && val.y !== null && val.y > 0),
            },
            {
              name: "Meta",
              animation: false,
              stickyTracking: false,
              type: "spline",
              data: this.categories
                .map(category => {
                  return category in this.metasKpis
                    ? { x: this.categories.indexOf(category), y: Number(this.metasKpis?.[category]?.[this.indicador]) } 
                    : { x: this.categories.indexOf(category), y: null }
                })
                .filter(val => val !== null && val.y !== null)
            }
          ],
        };
      },
    },
    watch: {
      dadosMensais() {
        this.setChartOptions();
      },
      indicador() {
        this.setChartOptions();
      },
    },
  };
</script>

<style></style>
